import { takeLatest } from 'redux-saga/effects';

import {
  loginSaga,
  signUpSaga,
  forgotPasswordSaga,
  resetPasswordSaga,
  createNewPasswordSaga,
  checkAuthenticationSaga,
  checkSsoAzureConfigSaga,
  checkSsoJwtConfigSaga,
  checkSsoSamlConfigSaga,
  checkPasswordResetTokenSaga,
} from 'sagas/auth.saga';
import {
  LOGIN,
  CHECK_AUTH,
  SIGNUP,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  CREATE_NEW_PASSWORD,
  CHECK_SSO_AZURE_CONFIG,
  CHECK_SSO_JWT_CONFIG,
  CHECK_SSO_SAML_CONFIG,
  CHECK_PASSWORD_RESET_TOKEN,
} from 'actions/app.actions';
import { REQUEST } from 'services/api';

export function* authWatcher(): Generator<any> {
  yield takeLatest(LOGIN[REQUEST], loginSaga);
}

export function* signUpSagaWatcher(): Generator<any> {
  yield takeLatest(SIGNUP[REQUEST], signUpSaga);
}

export function* forgotPasswordWatcher(): Generator<any> {
  yield takeLatest(FORGOT_PASSWORD[REQUEST], forgotPasswordSaga);
}

export function* resetPasswordWatcher(): Generator<any> {
  yield takeLatest(RESET_PASSWORD[REQUEST], resetPasswordSaga);
}
export function* createNewPasswordWatcher(): Generator<any> {
  yield takeLatest(CREATE_NEW_PASSWORD[REQUEST], createNewPasswordSaga);
}

export function* checkAuthenticationWatcher(): Generator<any> {
  yield takeLatest(CHECK_AUTH[REQUEST], checkAuthenticationSaga);
}

export function* checkSsoAzureConfigWatcher(): Generator<any> {
  yield takeLatest(CHECK_SSO_AZURE_CONFIG[REQUEST], checkSsoAzureConfigSaga);
}

export function* checkSsoJwtConfigWatcher(): Generator<any> {
  yield takeLatest(CHECK_SSO_JWT_CONFIG[REQUEST], checkSsoJwtConfigSaga);
}

export function* checkSsoSamlConfigWatcher(): Generator<any> {
  yield takeLatest(CHECK_SSO_SAML_CONFIG[REQUEST], checkSsoSamlConfigSaga);
}

export function* checkPasswordResetTokenWatcher(): Generator<any> {
  yield takeLatest(
    CHECK_PASSWORD_RESET_TOKEN[REQUEST],
    checkPasswordResetTokenSaga,
  );
}
